import BaseParameterAction from './BaseParameterAction.js';

class AddAutomationBreakPointAction extends BaseParameterAction {
    execute({automation, step, value, pointId}) {
        return {
            point: automation.addBreakPoint(step, value, pointId)
        };
    }

    undo({payload}) {
        payload.automation.removeBreakPoint(payload.point);
    }
}

export default AddAutomationBreakPointAction;
